const PRICING_CARDS = [
  {
    title: "Levels 1–6",
    desc: "Foundation and Core Practitioner — Networking through SOC Analyst.",
    was: "$99",
    price: "$49",
    per: "PER LEVEL · WAS $99",
    features: [
      "Any single level, standalone",
      "Recorded video, labs and graded project",
      "Online exam and level certificate included",
      "One free exam retake",
      "Fee credited to the full track within 60 days",
    ],
    cta: "Pick a level",
    ctaStyle: "border border-[#3f3f46] text-white hover:border-white",
    highlight: false,
  },
  {
    title: "Levels 7–10",
    desc: "Expert — GRC, automation, AI security and cloud security.",
    was: "$149",
    price: "$75",
    per: "PER LEVEL · WAS $149",
    features: [
      "Any single expert level, standalone",
      "Deeper labs and a client-grade deliverable",
      "Online exam and level certificate included",
      "One free exam retake",
      "Placement test if you want to skip ahead",
    ],
    cta: "Pick a level",
    ctaStyle: "border border-[#3f3f46] text-white hover:border-white",
    highlight: false,
  },
  {
    title: "Full Track — all 10 levels",
    desc: "52 weeks, 180 modules, 200 labs, 10 exams, 10 certificates and the HD-CCE.",
    was: "$1,190",
    price: "$499",
    per: "ONE-TIME PAYMENT · SAVE $691",
    features: [
      "Every level from zero to expert, in order",
      "CV Building & Mock Interview module free ($49 value)",
      "HD-CCE certificate on completion",
      "Lab range and video access for 18 months",
      "Career support from Level 6 onward",
    ],
    cta: "Enroll in the full track",
    ctaStyle: "bg-white text-black hover:bg-[#e4e4e7]",
    highlight: true,
  },
];

export default function EnrollSection() {
  return (
    <section
      id="enroll"
      className="border-t border-[#18181b] bg-[#050505] px-4 py-8 sm:p-10"
    >
      <div className="max-w-[1200px] mx-auto px-6 py-12 sm:py-22">
        <div className="max-w-[720px] mb-11">
          <div
            className="font-mono text-[12px] text-[#a3e635] mb-[18px]"
            style={{ letterSpacing: "0.18em" }}
          >
            11 — ENROLL
          </div>
          <h2
            className="font-bold text-white mb-[18px]"
            style={{
              fontSize: "clamp(30px, 3.7vw, 46px)",
              lineHeight: 1.06,
              letterSpacing: "-0.03em",
            }}
          >
            Enrol today, start in the next five minutes
          </h2>
          <p className="text-[16px] sm:text-[18px] leading-[1.65] text-[#a1a1aa]">
            Everything is online and self-paced, so there is no batch to wait
            for. Levels 1–6 are $49 each, Levels 7–10 are $75 each, and the
            whole ten-level track is $499 as a single payment — with the $49
            CV and mock-interview module thrown in free.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-5">
          {PRICING_CARDS.map((card, i) => (
            <div
              key={i}
              className={`border rounded-[14px] p-5 sm:p-8 bg-[#09090b] flex flex-col relative ${
                card.highlight ? "border-[#a3e635]" : "border-[#27272a]"
              }`}
            >
              {card.highlight && (
                <div
                  className="absolute -top-[11px] left-8 bg-[#a3e635] text-black font-mono text-[10px] px-2.5 py-1 rounded-[4px] font-bold"
                  style={{ letterSpacing: "0.14em" }}
                >
                  BEST VALUE
                </div>
              )}
              <div className="text-[17px] sm:text-[21px] font-bold mb-1.5" style={{ letterSpacing: "-0.02em" }}>
                {card.title}
              </div>
              <div className="text-[14px] text-[#71717a] leading-relaxed mb-5">
                {card.desc}
              </div>
              <div className="flex items-baseline gap-2.5 mb-1">
                <span className="font-mono text-[18px] text-[#52525b] line-through">
                  {card.was}
                </span>
                <span
                  className="text-[32px] sm:text-[42px] font-bold leading-none"
                  style={{ letterSpacing: "-0.03em" }}
                >
                  {card.price}
                </span>
              </div>
              <div
                className="font-mono text-[11px] text-[#71717a] mb-6"
                style={{ letterSpacing: "0.1em" }}
              >
                {card.per}
              </div>
              <div className="grid gap-2.5 mb-[26px]">
                {card.features.map((f, fi) => (
                  <div
                    key={fi}
                    className="flex gap-2.5 text-[14px] text-[#d4d4d8] leading-snug"
                  >
                    <span style={{ color: card.highlight ? "#a3e635" : "#71717a" }}>✓</span>
                    {f}
                  </div>
                ))}
              </div>
              <a
                href="#courses"
                className={`mt-auto block py-4 rounded-lg font-semibold text-[15px] text-center ${card.ctaStyle}`}
              >
                {card.cta}
              </a>
            </div>
          ))}
        </div>

        <div className="border border-[#27272a] rounded-[14px] bg-[#09090b] p-7 grid grid-cols-1 sm:grid-cols-[1fr_auto] gap-6 sm:gap-8 sm:items-center">
          <div>
            <div className="flex items-baseline gap-3 flex-wrap mb-2">
              <span className="text-[20px] font-bold" style={{ letterSpacing: "-0.02em" }}>
                CV Building & Mock Interview with an expert
              </span>
              <span
                className="font-mono text-[11px] text-[#a3e635]"
                style={{ letterSpacing: "0.12em" }}
              >
                STANDALONE — NO LEVELS REQUIRED
              </span>
            </div>
            <div className="text-[14px] text-[#a1a1aa] leading-[1.65] max-w-[720px]">
              Security CV and LinkedIn rewriting, ATS keywords, portfolio
              packaging, and a one-to-one mock technical interview with a
              practising professional plus written feedback. Complimentary
              for anyone who completes all ten levels — or buy it on its own,
              even if you have never studied with us.
            </div>
          </div>
          <div className="flex items-center gap-5">
            <div
              className="text-[34px] font-bold"
              style={{ letterSpacing: "-0.03em" }}
            >
              $49
            </div>
            <button
              type="button"
              className="border border-[#3f3f46] text-white px-6 py-3.5 rounded-lg font-semibold text-[15px]  hover:border-white transition-colors cursor-pointer bg-transparent font-[inherit]"
            >
              Buy this module
            </button>
          </div>
        </div>

        <div className="font-mono text-[11px] text-[#52525b] mt-4 leading-[1.8]">
          ALL PRICES IN USD · INSTALMENTS AVAILABLE · 7-DAY REFUND · NO LIVE
          CLASSES REQUIRED
        </div>
      </div>
    </section>
  );
}
